module.exports = __webpack_public_path__ + "static/media/sfa.cad99db3.jpg";